import cx from "classnames";
import { useState } from "react";
import { Button } from "..";
import TextButton from "./text-button";

export default function OtpBox({
  className = "",
  startIndex = 0,
  size = 4,
  onVerify = (otp) => {},
  onCancel,
  isLoading = false,
}) {
  const [otp, setOtp] = useState(Array(size).fill(""));

  const otpFilled = otp.filter((value) => value.length > 0).length === size;

  const setOtpOnIndex = (index, value) => {
    setOtp(
      otp.map((v, i) => {
        if (i === index) {
          return value;
        }
        return v;
      })
    );
    // focus to next node
    if (index < size - 1) {
      document.getElementById("OTPField" + (index + 1)).focus();
    }
  };

  return (
    <>
      <div
        className={cx(
          "OTPBox border rounded px-6 pb-3 mt-4 theme-border-default",
          className
        )}>
        {otp.map((value, index) => (
          <OTPField
            key={index}
            otp={value}
            index={startIndex * size + index}
            isLast={index === otp.length - 1}
            setOtpOnIndex={setOtpOnIndex}
          />
        ))}
      </div>
      <div className="flex">
        <Button
          label="Verify"
          onClick={(e) => {
            onVerify(otp.join(""));
          }}
          disabled={!otpFilled}
          className="mt-4"
          isLoading={isLoading}
        />
        {onCancel ? (
          <TextButton
            label="Cancel"
            onClick={onCancel}
            className="ml-2 mt-4"
            isLoading={isLoading}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

function OTPField({
  otp = "",
  setOtpOnIndex = (index, value) => {},
  index = "",
  isLast = false,
}) {
  return (
    <input
      type="text"
      id={"OTPField" + index}
      className={cx(
        "OTPField bg-transparent theme-border-default hover:theme-border-primary border-b",
        {
          filled: otp.length > 0,
        }
      )}
      onFocus={(e) => {
        e.target.select();
      }}
      autoComplete="new-password"
      value={otp}
      onClick={(e) => {
        e.target.select();
      }}
      onChange={(e) => {
        if (e.target.value.length > 0) {
          const value = e.target.value[e.target.value.length - 1];
          if (/^(\d){1}$/.test(value)) {
            setOtpOnIndex(index, value);
          }
        }
      }}
    />
  );
}
